
import React from 'react';
import { Link } from 'react-router-dom';

const OrderHistoryPage: React.FC = () => {

  // 模擬訂單數據
  const mockOrders = [
    {
      id: `HL${Date.now().toString().slice(-8)}`,
      date: new Date().toLocaleDateString('zh-TW'),
      status: '已確認',
      totalAmount: 'NT$ 3,200',
      items: [
        { name: '台鐵普悠瑪號', price: 'NT$ 440', type: '交通' },
        { name: '海景民宿', price: 'NT$ 1,800', type: '住宿' },
        { name: '共用工作空間', price: 'NT$ 400', type: '工作空間' },
        { name: '阿美族豐年祭體驗', price: 'NT$ 800', type: '文化體驗' }
      ],
      statusColor: 'text-green-600',
      statusBg: 'bg-green-100'
    },
    {
      id: `HL${(Date.now() - 86400000).toString().slice(-8)}`,
      date: new Date(Date.now() - 86400000).toLocaleDateString('zh-TW'),
      status: '已完成',
      totalAmount: 'NT$ 2,800',
      items: [
        { name: '客運巴士', price: 'NT$ 300', type: '交通' },
        { name: '市區飯店', price: 'NT$ 1,500', type: '住宿' },
        { name: '玉石文化之旅', price: 'NT$ 1,000', type: '文化體驗' }
      ],
      statusColor: 'text-blue-600',
      statusBg: 'bg-blue-100'
    }
  ];

  const getStatusIcon = (status: string) => {
    switch (status) {
      case '已確認':
        return '✅';
      case '已完成':
        return '✅';
      case '處理中':
        return '⏳';
      case '已取消':
        return '❌';
      default:
        return '📋';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        {/* 頁面標題 */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            歷史訂單
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            查看您的所有訂單記錄和詳細資訊
          </p>
        </div>

        {/* 訂單列表 */}
        <div className="space-y-6">
          {mockOrders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-2xl shadow-soft p-6 hover:shadow-medium transition-all duration-300"
            >
              {/* 訂單標題行 */}
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-4">
                  <div className="text-2xl">{getStatusIcon(order.status)}</div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">
                      訂單 #{order.id}
                    </h3>
                    <p className="text-sm text-gray-500">
                      下單日期：{order.date}
                    </p>
                  </div>
                </div>
                
                <div className="text-right">
                  <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${order.statusBg} ${order.statusColor}`}>
                    {order.status}
                  </div>
                  <p className="text-lg font-bold text-gray-800 mt-1">
                    {order.totalAmount}
                  </p>
                </div>
              </div>

              {/* 訂單項目 */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                {order.items.map((item, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-medium text-gray-800">{item.name}</p>
                        <p className="text-sm text-gray-500">{item.type}</p>
                      </div>
                      <span className="font-semibold text-gray-700">{item.price}</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* 操作按鈕 */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                <div className="flex space-x-3">
                  <button className="px-4 py-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-xl transition-colors duration-300 text-sm font-medium">
                    查看詳情
                  </button>
                  <button className="px-4 py-2 bg-green-100 hover:bg-green-200 text-green-700 rounded-xl transition-colors duration-300 text-sm font-medium">
                    重新預約
                  </button>
                </div>
                
                <button className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-colors duration-300 text-sm font-medium">
                  下載收據
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* 空狀態 */}
        {mockOrders.length === 0 && (
          <div className="text-center py-12">
            <div className="text-6xl mb-4">📋</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              還沒有訂單記錄
            </h3>
            <p className="text-gray-600 mb-6">
              開始您的第一次預約，體驗花蓮數位游牧的魅力
            </p>
            <Link
              to="/start"
              className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-medium"
            >
              開始預約
            </Link>
          </div>
        )}

        {/* 返回按鈕 */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-xl transition-all duration-300"
          >
            ← 返回首頁
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryPage; 